
// import IndexLeft from '@/components/admin/IndexLeft'
const IndexLeft = () =>import( '@/components/admin/IndexLeft')
const ManagerList = () =>import( '@/components/admin/manager/ManagerList')
// import ManagerList from '@/components/admin/manager/ManagerList'
// import ManagerRole from '@/components/admin/manager/ManagerRole'
const ManagerRole = () =>import( '@/components/admin/manager/ManagerRole')
// Vue.use(Router)
export default [
  {
    path: '/admin/managers',
    name: 'ManagerList',
    components: {indexLeft: IndexLeft, indexRight: ManagerList}
  },
  {
    path: '/admin/managers/role',
    name: 'ManagerRole',
    components: {indexLeft: IndexLeft, indexRight: ManagerRole}
  }
]



// WEBPACK FOOTER //
// ./src/router/managerRouter.js